.read-more {
  position: relative;
  min-width: 0;
  overflow: hidden;
  /* TODO: consider of height transition */
  transition: min-width 200ms ease;
}

.expandable::after {
  position: absolute;
  z-index: 3;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  content: '';
}

.fade-white.expandable::after {
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--rc-theme-color-surface-default) 0%, transparent) 0%,
    color-mix(in srgb, var(--rc-theme-color-surface-default) 80%, transparent) 39.06%,
    var(--rc-theme-color-surface-default) 63.54%
  );
}

.fade-light.expandable::after {
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--rc-theme-color-surface-subtle) 0%, transparent) 0%,
    color-mix(in srgb, var(--rc-theme-color-surface-subtle) 80%, transparent) 39.06%,
    var(--rc-theme-color-surface-subtle) 63.54%
  );
}

.fade-primary.expandable::after {
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--rc-theme-color-primary-default) 0%, transparent) 0%,
    color-mix(in srgb, var(--rc-theme-color-primary-default) 80%, transparent) 39.06%,
    var(--rc-theme-color-primary-default) 63.54%
  );
}

.expandable {
  min-width: 100px;
  max-height: var(--read-more-collapsed-max);
}

.collapsible {
  padding-bottom: var(--rc-theme-spacing-lg);
}

.expanded {
  max-height: unset;
}

.expanded::after {
  display: none;
}

.button {
  display: flex;
  position: absolute;
  z-index: 4;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.button--padding-bottom {
  bottom: 16px;
}

.button svg {
  position: relative;
  width: 16px;
  height: 16px;
}
